export default "closeae9a994387c3232e.svg"